import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import _get from "lodash/get";

import language from "constants/language";
import { changeLanguage } from "redux/actions";

export default () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const currentLanguage = useSelector(state => state.System.language);
  const history = useHistory();

  const [state, setState] = useState({
    dropdownOpen: false
  });

  const toggleDropdown = () => setState({ ...state, dropdownOpen: !state.dropdownOpen });
  const onChangeLanguageHandler = langCode => {
    localStorage.setItem("language", langCode);
    history.push(window.location)
    dispatch(changeLanguage(langCode))
  };

  return (
    <Dropdown isOpen={state.dropdownOpen} toggle={toggleDropdown} className="notification-list">
      <DropdownToggle
        data-toggle="dropdown"
        tag="button"
        className="btn btn-link nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"
        onClick={toggleDropdown}
        aria-expanded={state.dropdownOpen}>
        <span className="pro-user-name ml-1">
          {_get(language, ["list", currentLanguage, "title"])} <i className="mdi mdi-chevron-down"></i>{" "}
        </span>
      </DropdownToggle>
      <DropdownMenu right className="topbar-dropdown-menu profile-dropdown">
        <div onClick={toggleDropdown}>
          <div className="dropdown-header noti-title">
            <h6 className="text-overflow m-0">{t("global.choose_display_language")}</h6>
          </div>
          {Object.keys(language.list).map(langCode => {
            const { title: langTitle } = language.list[langCode];

            return (
              <button
                key={langCode}
                className="dropdown-item notify-item"
                onClick={() => onChangeLanguageHandler(langCode)}>
                {langTitle}
              </button>
            );
          })}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};
